import { useAssessment } from '../../context/AssessmentContext'
import { getAllDASSQuestions } from '../../data/dassQuestions'
import InvestorMetricsEngine from '../../services/InvestorMetricsEngine'
import Shell from '../ui/Shell'
import AnswerRows from '../ui/AnswerRows'
import { getProgress, computeDassScores, STEP_LABEL, primaryIsActive } from '../../lib/flow'
import { buildAreaResults, scoreBarc10 } from '../../lib/onboardingScoring'

const ANSWERS = [
  { title: 'Did not apply to me at all' },
  { title: 'Applied to me some of the time' },
  { title: 'Applied to me a good part of the time' },
  { title: 'Applied to me most of the time' },
]

function DASSAssessment() {
  const { state, dispatch } = useAssessment()
  const questions = getAllDASSQuestions()
  const question = questions[state.currentDASSIndex]
  const total = questions.length

  if (!question) {
    dispatch({ type: 'SET_SCREEN', payload: 'addictionSelection' })
    return null
  }

  const finish = (allAnswers) => {
    const dassScores = computeDassScores(allAnswers)
    dispatch({ type: 'SET_DASS_SCORES', payload: dassScores })

    const areaResults = buildAreaResults({
      selected: state.selectedAddictions,
      gates: state.gates,
      primary: state.primaryAddiction,
      screener: state.screenerAnswers,
    })
    dispatch({ type: 'SET_AREA_RESULTS', payload: areaResults })
    dispatch({ type: 'SET_BARC_SCORE', payload: scoreBarc10(state.barc10Answers) })

    const engine = new InvestorMetricsEngine(areaResults, dassScores, state.userAge || 35, null)
    dispatch({ type: 'SET_INVESTOR_METRICS', payload: engine.generateAllMetrics() })
    dispatch({ type: 'SET_SCREEN', payload: 'emailCollection' })
  }

  const answer = (answerIndex) => {
    dispatch({ type: 'ANSWER_DASS_QUESTION', payload: { questionId: question.id, answerIndex } })
    if (state.currentDASSIndex < total - 1) dispatch({ type: 'NEXT_DASS_QUESTION' })
    else finish({ ...state.dassAnswers, [question.id]: answerIndex })
  }

  const back = () => {
    if (state.currentDASSIndex > 0) {
      dispatch({ type: 'PREV_DASS_QUESTION' })
      return
    }
    dispatch({ type: 'SET_SCREEN', payload: primaryIsActive(state) ? 'screener' : 'barc10' })
  }

  return (
    <Shell label={STEP_LABEL.dassAssessment} progress={getProgress(state)} onBack={back}>
      <main className="flow">
        <div className="q" key={question.id}>
          <div className="q__meta">
            <span>{state.currentDASSIndex + 1} of {total}</span>
            <span>Past 7 days</span>
          </div>
          <div className="q__body">
            <p className="q__frame">Over the past week…</p>
            <h1 className="q__text" style={{ marginTop: 8 }}>{question.question}</h1>
          </div>
          <div className="q__body" style={{ animationDelay: '40ms' }}>
            <AnswerRows options={ANSWERS} value={state.dassAnswers[question.id] ?? null} onChoose={answer} />
          </div>
        </div>
      </main>
    </Shell>
  )
}

export default DASSAssessment
